<template>
  <AvatarRoot
    :class="cn(variants({ size, active, shape }), props.class)"
    :key="item.imageUrl"
  >
    <AvatarImage
      :src="`${item.imageUrl}`"
      :alt="item.name"
      @loadingStatusChange="loadingStatus"
    />
    <AvatarFallback>
      <LoadingSpinner v-if="loading" variant="light" size="xs" />
      <Icon
        v-else
        name="building-happy"
        :size="size"
        variant="fill"
        class="placeholder"
      />
    </AvatarFallback>
  </AvatarRoot>
</template>

<script setup>
import { ref } from "vue";
import { AvatarRoot } from "radix-vue";
import { AvatarImage, AvatarFallback } from "@/SharedComponents/Avatars";
import { variants, sizes, shapes } from "./building";
import { LoadingSpinner } from "@/SharedComponents/LoadingSpinner";
import { Icon } from "@/SharedComponents/Icon";
import { cn } from "@/Utils/cn";

const props = defineProps({
  item: { type: Object, required: true },
  shape: {
    type: String,
    validator: (val) => shapes.includes(val),
    default: "square",
  },
  size: {
    type: String,
    validator: (val) => sizes.includes(val),
    required: false,
  },
  active: { type: Boolean, required: false },
  class: { type: null, required: false },
});

const loading = ref(!!props.item.imageUrl);

const loadingStatus = (event) => {
  if (!props.item.imageUrl) {
    return;
  }

  if (event === "loading") {
    loading.value = true;
    return;
  }

  loading.value = false;
};
</script>
